import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1177 9.63863c-.0773-.36738-.11804-.74826-.11804-1.13863 0-3.038 2.46304-5.5 5.50014-5.5.6731 0 1.3151.127 1.9111.348l-3.2071 3.207c-.716.716-.716 1.877 0 2.593l.648.648c.716.716 1.8771.716 2.5931 0l3.2071-3.207c.222.596.348 1.238.348 1.911 0 3.037-2.4621 5.5-5.5002 5.5-.3905 0-.7716-.0407-1.1391-.1182l-6.23929 6.2391c-1.17204 1.172-3.0711 1.172-4.24313 0-1.17104-1.172-1.17104-3.071 0-4.243l6.23942-6.23927z",
    fill: "currentColor"
  }));
});